// extracted by mini-css-extract-plugin
export var card = "_mb-5";
export var cardSelected = "_mb-4";
export var image = "_mb-3";
export var modal = "_mb-0";
export var modalContent = "_mb-1";
export var table = "_mb-2";